module.exports = __webpack_public_path__ + "static/media/LINK-BRL.93fc7d3c.svg";